export default class VolumeMeter {
  constructor() {
    this._remoteContexts = new Map();
    this._localGeneration = 0;
  }

  unbindRemote(uid) {
    const ctx = this._remoteContexts.get(uid);
    if (ctx) {
      ctx.close().catch(() => {});
      this._remoteContexts.delete(uid);
    }
  }

  async remoteBind(stream, uid) {
    if (!stream || stream.getAudioTracks().length === 0) {
      console.warn("VolumeMeter.remoteBind: stream has no audio tracks, skipping");
      return;
    }
    this.unbindRemote(uid);
    try {
      var that = this;
      var remote_audio_context = new AudioContext();
      this._remoteContexts.set(uid, remote_audio_context);
      let micBar = document.querySelector(`#user-row-${uid} .mic-level-bar`);

      let _pendingVol = null;
      let _rafId = null;
      let _smoothedVol = 0;
      const scheduleUpdate = (vol) => {
        const factor = vol > _smoothedVol ? 0.35 : 0.08;
        _smoothedVol = _smoothedVol + (vol - _smoothedVol) * factor;
        _pendingVol = _smoothedVol;
        if (_rafId === null) {
          _rafId = requestAnimationFrame(() => {
            _rafId = null;
            that.colorRemoteMicBar(_pendingVol, micBar);
          });
        }
      };

      try {
        if (typeof AudioWorklet !== "undefined") {
          await remote_audio_context.audioWorklet.addModule(
            "https://app.iris.fm/volume_meter_worklet.js",
          );
          const volume_meter_worklet = new AudioWorkletNode(
            remote_audio_context,
            "VolumeMeterWorklet",
          );
          let source = new MediaStreamAudioSourceNode(remote_audio_context, {
            mediaStream: stream,
          });
          source
            .connect(volume_meter_worklet)
            .connect(remote_audio_context.destination);

          volume_meter_worklet.port.onmessage = (event) =>
            scheduleUpdate(event.data.volume * 100 * 2);
          console.log("creating AUDIOWorklet");
          return;
        }
      } catch (error) {
        console.log("cant create audioworklet");
        console.error(error);
      }
      console.log("creating AUDIO main_thread");
      var mediaStreamSource =
        remote_audio_context.createMediaStreamSource(stream);
      var processor = remote_audio_context.createScriptProcessor(2048, 1, 1);

      mediaStreamSource.connect(processor);
      processor.connect(remote_audio_context.destination);
      processor.onaudioprocess = function (e) {
        var inputData = e.inputBuffer.getChannelData(0);
        var total = 0;
        for (var i = 0; i < inputData.length; i++) {
          total += Math.abs(inputData[i]);
        }
        var rms = Math.sqrt(total / inputData.length);
        scheduleUpdate(rms * 100 * 2);
      };
    } catch (e) {
      if (e instanceof NotSupportedError) {
        console.log("cant create anymore audio contexts"); //Failed to construct 'AudioContext': The number of hardware contexts provided (6) is greater than or equal to the maximum bound (6)
      } else {
        throw e;
      }
    }
  }

  colorRemoteMicBar(vol, micBar) {
    if (!micBar) return;
    const color = vol > 100 ? "#ef4444" : vol > 70 ? "#fbbf24" : "#22c55e";
    micBar.style.width = Math.min(Math.round(vol), 100) + "%";
    micBar.style.backgroundColor = color;
  }

  async bind(stream) {
    if (!stream || stream.getAudioTracks().length === 0) {
      console.warn("VolumeMeter.bind: stream has no audio tracks, skipping");
      return;
    }
    var that = this;
    const generation = ++this._localGeneration;
    local_audio_context = new AudioContext();
    var mic_bars = document.querySelectorAll(
      `.mic-level-bar.local-bar, #user-row-${options.uid} .mic-level-bar`,
    );

    let _pendingVol = null;
    let _rafId = null;
    let _smoothedVol = 0;
    const scheduleUpdate = (vol) => {
      if (that._localGeneration !== generation) return; // stale closure, newer bind() was called
      const factor = vol > _smoothedVol ? 0.35 : 0.08;
      _smoothedVol = _smoothedVol + (vol - _smoothedVol) * factor;
      _pendingVol = _smoothedVol;
      if (_rafId === null) {
        _rafId = requestAnimationFrame(() => {
          _rafId = null;
          if (that._localGeneration !== generation) return;
          that.colorLocalMicBars(_pendingVol, mic_bars);
        });
      }
    };

    try {
      if (typeof AudioWorklet !== "undefined") {
        await local_audio_context.audioWorklet.addModule(
          "https://app.iris.fm/volume_meter_worklet.js",
        );
        const volume_meter_worklet = new AudioWorkletNode(
          local_audio_context,
          "VolumeMeterWorklet",
        );
        let source = new MediaStreamAudioSourceNode(local_audio_context, {
          mediaStream: stream,
        });
        source
          .connect(volume_meter_worklet)
          .connect(local_audio_context.destination);

        volume_meter_worklet.port.onmessage = (event) =>
          scheduleUpdate(event.data.volume * 100 * 2);
        console.log("createted AUDIO WORKLET");
        return;
      }
    } catch (error) {
      console.warn("AudioWorklet fallback to ScriptProcessor", error);
    }
    console.log("creating AUDIO main thread");

    if (stream.getAudioTracks().length === 0) {
      console.warn("VolumeMeter.bind: stream lost audio tracks during setup, skipping");
      return;
    }
    var mediaStreamSource = local_audio_context.createMediaStreamSource(stream);
    var processor = local_audio_context.createScriptProcessor(2048, 1, 1);
    mediaStreamSource.connect(processor);
    processor.connect(local_audio_context.destination);

    processor.onaudioprocess = function (e) {
      var inputData = e.inputBuffer.getChannelData(0);
      var total = 0;
      for (var i = 0; i < inputData.length; i++) {
        total += Math.abs(inputData[i]);
      }
      var rms = Math.sqrt(total / inputData.length);
      scheduleUpdate(rms * 100 * 2);
    };
  }

  colorLocalMicBars(vol, mic_bars) {
    const color = vol > 100 ? "#ef4444" : vol > 70 ? "#fbbf24" : "#22c55e";
    mic_bars.forEach((micBar) => {
      micBar.style.width = Math.min(Math.round(vol), 100) + "%";
      micBar.style.backgroundColor = color;
    });
  }
}
